import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormStatusPipe } from './formStatus.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [FormStatusPipe],
    providers: [FormStatusPipe],
    exports: [FormStatusPipe],
})
export class FormStatusPipeModule {}
